import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const FacebookLoginButton = ({ text, handler }) => {
  const variantButton = text === StringConstantsMixin.strings.FACEBOOK.FACEBOOK_SETTINGS ? 'facebookSettings' : 'facebookLogin';

  return <SubmitButton text={text} handler={handler} variant={variantButton} />;
};

FacebookLoginButton.defaultProps = {
  text: 'Continue with Apple',
  handler: () => {}
};

FacebookLoginButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func
};

export default FacebookLoginButton;
